import { render, staticRenderFns } from "./DocumentsInformation.vue?vue&type=template&id=0e125606&scoped=true"
import script from "./DocumentsInformation.vue?vue&type=script&lang=js"
export * from "./DocumentsInformation.vue?vue&type=script&lang=js"
import style0 from "./DocumentsInformation.vue?vue&type=style&index=0&id=0e125606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e125606",
  null
  
)

export default component.exports